<template lang="pug">
div.body-lo
  div.modal-header
    span.lo-modal-title HOÀN THÀNH BÀI TẬP
    span.lo-modal-btn-close.material-icons(@click="closePopupFinish") close
  div.modal-body
    div.reg-content Bạn đã hoàn thành bài tập, nội dung làm bài của bạn sẽ được gửi về giáo viên này. 
      abbr(v-if="!fromClass") Tham gia các lớp học của giáo viên để tiếp cận nhiều bài tập hay hơn nữa:
  div.modal-footer.lo-custom-footer
    div.row
      div.col-md-12.col-12.text-center
        a.lo-btn-continue.lo-popup-pc.btn(@click='continuteTeacherFinish' v-if="!fromClass") Lớp học của giáo viên
        a.lo-btn-continue.lo-popup-pc.btn(@click='continuteTeacherFinish' v-else) Xác nhận
</template>
<script>
export default {
  props: {
    closePopup: Function,
    continuteTeacher: Function,
    fromClass: Boolean
  },
  methods: {
    continuteTeacherFinish() {
      this.continuteTeacher({dataReturn: 2})
      this.$nextTick(() => {
        this.$emit('close')
      })
    },
    closePopupFinish() {
      this.$nextTick(() => {
        this.$emit('close')
      })
      this.closePopup({dataReturn: 1})
    }
  }
}
</script>
<style lang="scss">
:root {
  // Color 
  --color-background-button: #FFD311;
}
.body-lo {
  margin-left: 5px;
  margin-right: 5px;
  background-color: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px;
  .lo-modal-title {
    font-family: 'adobe-clean', sans-serif;
    float: left;
    font-size: 17px;
  }
  .lo-modal-btn-close {
    float: right;
    &:hover {
      cursor: pointer;
    }
  }
  .reg-content{
      span{color: #333333; font-size: 15px; font-weight: bold;}
  }
  .note{margin-top: 20px;}
  .lo-body-title {
    color: var(--color-type-selected);
    margin-bottom: 0;
    padding-bottom: 3px;
  }
  .lo-btn-continue {
    background: var(--color-background-button);
    color: #000;
    text-transform: none;
    font-size: 13px;
    font-family: 'adobe-clean', sans-serif;
    border: 1px solid #FFD311;
    border-radius: 5px;
    // box-shadow: 0px 0px 0px;
    width: 160px;
    padding-left: 0;
    padding-right: 0;
    margin-top: 0 !important;
    margin-bottom: 15px;
  }
  .lo-popup-pc{color: #23180A; font-size: 14px;}
  .lo-btn-back {
    background: white;
    color: black;
    text-transform: none;
    font-size: 13px;
    font-family: 'adobe-clean', sans-serif;
    border: 1px solid #FFD311;
    border-radius: 5px;
    // box-shadow: 0px 0px 0px;
    width: 160px;
    margin-top: 0 !important;
  }
  .lo-custom-footer {
    padding: 0;
    border: 0;
  }
// cellphones 
@media (max-width: 414px) {
  .lo-btn-continue {
    float: left;
    margin-left: 40px;
    width: 115px;
  }
  .lo-btn-back {
    float: right;
    margin-right: 40px;
    width: 115px;
  }
}
}
</style>



// WEBPACK FOOTER //
// popup.vue?e414a888